import axios from "axios";
import { getDomainFromToken } from "../../../commons/Auth/auth";

const base = `${process.env.REACT_APP_BACKEND_URL}/subcontractors`;
const token = () => localStorage.getItem("token");
const headers = () => ({ headers: { Authorization: "Bearer " + token() } });

const formOf = (fields, file) => {
  const body = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") body.append(key, String(value));
  });
  if (file) body.append("file", file, file.name);
  return body;
};

export const getMeta = () => axios.get(`${base}/meta`, headers());
export const listSubcontractors = params => axios.get(base, { ...headers(), params });
export const getSubcontractor = id => axios.get(`${base}/${id}`, headers());
export const createSubcontractor = body => axios.post(base, body, headers());
export const updateSubcontractor = (id, body) => axios.put(`${base}/${id}`, body, headers());
export const deleteSubcontractor = id => axios.delete(`${base}/${id}`, headers());
export const runExpiryCheck = () => axios.post(`${base}/check-expiry`, {}, headers());

export const addDocument = (id, fields, file) =>
  axios.post(`${base}/${id}/documents`, formOf(fields, file), headers());
export const updateDocument = (id, docId, body) =>
  axios.put(`${base}/${id}/documents/${docId}`, body, headers());
export const deleteDocument = (id, docId) =>
  axios.delete(`${base}/${id}/documents/${docId}`, headers());
export const extractDocument = (id, docId) =>
  axios.post(`${base}/${id}/documents/${docId}/extract`, {}, headers());
export const createUploadLink = (id, body) =>
  axios.post(`${base}/${id}/upload-link`, body, headers());
export const revokeUploadLink = (id, linkId) =>
  axios.delete(`${base}/${id}/upload-link/${linkId}`, headers());

export const listOrders = params => axios.get(`${base}/orders`, { ...headers(), params });
export const createOrder = body => axios.post(`${base}/orders`, body, headers());
export const updateOrder = (id, body) => axios.put(`${base}/orders/${id}`, body, headers());
export const deleteOrder = id => axios.delete(`${base}/orders/${id}`, headers());
export const previewPayment = (id, body) =>
  axios.post(`${base}/orders/${id}/payment-check`, body, headers());
export const releasePayment = (id, body) =>
  axios.post(`${base}/orders/${id}/payments`, body, headers());

export const getComplianceMap = () => axios.get(`${base}/compliance-map`, headers());
export const getBelegCheck = belegId => axios.get(`${base}/beleg-check/${belegId}`, headers());

// A scan opens in a new tab, which cannot send a header: token and tenant go in the query.
export const documentFileUrl = (id, docId) =>
  `${base}/${id}/documents/${docId}/file?token=${encodeURIComponent(token() || "")}&domain=${encodeURIComponent(getDomainFromToken() || "")}`;

// The subcontractor's upload page (no login; the tenant comes from ?domain=)
const publicBase = `${process.env.REACT_APP_BACKEND_URL}/public-subcontractors`;
const domainQuery = domain => `?domain=${encodeURIComponent(domain || "")}`;
export const getPublicRequest = (token, domain) =>
  axios.get(`${publicBase}/${token}${domainQuery(domain)}`);
export const uploadPublicDocument = (token, domain, fields, file) =>
  axios.post(`${publicBase}/${token}/documents${domainQuery(domain)}`, formOf(fields, file));
